// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcp_a bhg_b bhg_uy bhg_rt bhg_ru bhg_vs","PanelFooter--link":"bcp_b"};